<script>
/**
 * This is used as a transparent component wrapper which can be overwritten.
 */

export default {
  name: 'Transparent',

  functional: true,

  render: (h, ctx) => {
    return ctx.scopedSlots.default && ctx.scopedSlots.default();
  },
};
</script>
